const { trackMetric } = require('../collector');
const { supportsPerformanceApi } = require('../support');
const { toFixedNumber } = require('../utils/number');
const { DURATION_SUM, RESOURCE_SIZE } = require('../../constants/metrics');

const firstPartyDomain = 'http2.mlstatic.com';

const durationInformationMonitor = () => {
  if (!supportsPerformanceApi()) {
    return;
  }
  // First party Only
  const resources = window.performance.getEntriesByType('resource')
    // eslint-disable-next-line security/detect-non-literal-regexp
    .filter((entry) => (new RegExp(firstPartyDomain)).test(entry.name));

  const durationSum = resources.reduce((a, c) => {
    // eslint-disable-next-line no-param-reassign
    a += c.duration;
    return a;
  }, 0);

  trackMetric(DURATION_SUM, toFixedNumber(durationSum));
  trackMetric(RESOURCE_SIZE, resources.length);
};

module.exports = durationInformationMonitor;
